import { observable, action, useStrict, runInAction, autorun, flow, toJS } from 'mobx';
import { Toast } from 'antd-mobile';
import Stores from 'config/Stores';
import Util from 'utils';
import { initConfig } from 'utils/wxUtils';
import { shareFriend, sharePyq } from 'utils/wxShare';
import Serv from './BusinessCardServ';
import { data } from 'jquery';
import Config from 'config/Config';
import { routeAuthCodeMap } from 'utils/constants';

class BusinessCardMod {
  // 名片信息
  @observable info = {};

  @observable decyptInfo = {};

  // 热门资讯
  @observable hotList = [];

  // 最新三条资讯
  @observable newsList = [];

  //推荐产品
  @observable listData = [];

  //用户选择的促销活动
  @observable selectActivityObject = {};

  //促销活动
  @observable activityList = [];

  //获取推荐商品数据
  @observable productRecommendList = [];

  //获取推荐商品的id集合
  @observable productRecommendIdList = [];

  //获取视频列表
  @observable videoList = [];

  // 获取用户选择的视频列表
  @observable selectVideo = {};

  // 数据总览 不同时间段信息内容 {对象}
  @observable reportObject = {};

  //公司介绍
  @observable companyIntroduce = {};

  @observable showQuesModal = {};

  // 二维码是否被禁用状态
  @observable mgmtQrStatus = '';

  @observable flagModal = false;
  @observable showMadol = false;
  @observable cardModuleTemplateData = [];

  // 手机号加密状态
  @observable isSecret = true;

  // 未登陆的情况下，是否存在下载app的权限点
  @observable hasPermissions = false;

  constructor() {
    this.init();
  }

  @action
  init() {
    const { decyptInfo } = Util.getLocalCache(Config.localStorageKeys.bussiness_card) || {};
    this.decyptInfo = decyptInfo || {};
    this.isSecret = !this.decyptInfo.phone;
  }

  @action
  changeModState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 获取名片详情
   */
  getCardInfo = flow(function* (id) {
    // console.log(id,'打印这个id');
    try {
      const { decyptInfo } = Util.getLocalCache(Config.localStorageKeys.bussiness_card) || {};
      const { data, resultCode, resultMsg } = yield Serv.getCardInfo(id ? { id } : '');
      if (resultCode == '100000') {
        Toast.fail(resultMsg, 1, () => {
          window.app.routerGoTo('/login');
        });
        return;
      }
      // 电话中间加空格
      // let phone = data.phone ? `${data.phone.slice(0, 3)} ${data.phone.slice(3, 7)} ${data.phone.slice(7, 11)}` : '';
      // this.info = {...data, phone} || {};
      this.info = { ...data, ...this.decyptInfo, ...decyptInfo } || {};
    } catch (error) {}
  });

  /**
   * 更新名片
   */
  saveMsg = flow(function* (params) {
    try {
      console.log(this.info.id, '这个名片数据');
      if (!this.info.id) {
        this.getCardInfo();
        Toast.fail('保存失败，请稍后重试');
        return;
      }
      params.id = this.info.id;
      const { data } = yield Serv.saveMsg(params);
      Toast.success('保存成功!', 1, () => {
        window.app.router.goBack();
      });
    } catch (error) {}
  });

  /**
   * 获取最新三条资讯
   */
  getLateNews = flow(function* () {
    try {
      const { data } = yield Serv.getLateNews();
      if (Array.isArray(data)) {
        this.newsList = data;
      }
    } catch (error) {}
  });
  /**
   * 获取推荐产品数据
   */
  getImgText = flow(function* () {
    try {
      const { data } = yield Serv.getImgText();
      if (Array.isArray(data)) {
        // this.listData.concat(data.map(item => ({...item})))
        this.listData = data[0].itemList;
        // this.listData = this.listData.concat(data.map(item => ({...item})));
        // console.log(JSON.stringify(this.listData));
      }
    } catch (error) {}
  });
  /**
   * 获取用户勾选的促销活动
   */
  getSelectActivityList = flow(function* (param) {
    try {
      const { data, resultCode } = yield Serv.getSelectActivityList(param);
      if (resultCode == 0) {
        this.selectActivityObject = data;
      }
    } catch (error) {}
  });
  /**
   * 获取用户相关的所有促销活动
   */
  getUserActivityList = flow(function* () {
    try {
      const { data, resultCode } = yield Serv.getUserActivityList();
      if (resultCode == 0) {
        this.activityList = data;
      }
    } catch (error) {
      console.log(error);
    }
  });
  /**
   * 关联用户合活动
   */
  getUserConnectActivity = flow(function* (params) {
    try {
      const { resultCode } = yield Serv.getUserConnectActivity(params);
      if (resultCode == 0) {
        return resultCode;
      }
    } catch (error) {
      console.log(error);
    }
  });
  /**
   * 获取名片模板数据
   */
  getCardModuleTemplate = flow(function* () {
    try {
      const belongSystem = Object.fromEntries(
        new URLSearchParams(window.location.href.split('?')[1])
      )['belongSystem'];
      // if ([undefined, 'undefined'].includes(belongSystem)) {
      //   return;
      // }
      const belongSystemCode = belongSystem || Stores.AppMod.userInfo.belongSystem;
      if (!belongSystemCode || 'undefined' == belongSystemCode) {
        return;
      }
      const { resultCode, data } = yield Serv.getCardModuleTemplate(
        belongSystem || Stores.AppMod.userInfo.belongSystem
      );
      if (resultCode == 0) {
        this.cardModuleTemplateData = data;
      }
    } catch (error) {
      console.log(error);
    }
  });
  /**
   * 添加推荐商品
   */
  addProductRecommend = flow(function* (params) {
    try {
      const { resultCode } = yield Serv.addProductRecommend(params);
      return resultCode == 0 ? resultCode : -1;
    } catch (error) {
      console.log(error);
    }
  });
  /**根据用户获取勾选的推荐商品
   */
  getProductRecommendList = flow(function* (params) {
    try {
      const { data, resultCode } = yield Serv.getProductRecommendList(params);
      if (resultCode == 0) {
        data.forEach((item, index) => {
          item.isRequired = false;
        });
        this.productRecommendList = data;
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  });
  /**根据用户获取勾选的推荐商品id集合
   */
  getProductRecommendIdList = flow(function* (params) {
    try {
      const { data, resultCode } = yield Serv.getProductRecommendIdList(params);
      if (resultCode == 0) {
        this.productRecommendIdList = data;
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  });
  /**
   * 删除勾选的推荐商品
   */
  productDelete = flow(function* (params) {
    try {
      const { data, resultCode } = yield Serv.productDelete(params);
      if (resultCode == 0) {
        return resultCode;
      }
    } catch (error) {
      // console.log(error);
    }
  });

  /**
   * 获取视频列表
   */
  getVideoList = flow(function* () {
    try {
      const { data, resultCode } = yield Serv.getVideoList();
      if (resultCode == 0) {
        this.videoList = data;
        return data;
      }
    } catch (error) {
      // console.log(error);
    }
  });

  /**
   * 获取用户选择的视频列表
   */
  getSelectVideoList = flow(function* (params) {
    try {
      const { data, resultCode } = yield Serv.getSelectVideoList(params);
      if (resultCode == 0) {
        this.selectVideo = data;
        return data;
      }
    } catch (error) {}
  });

  /**
   * 数据总览信息上报
   */
  addComeIn = flow(function* (params) {
    try {
      const { data, resultCode } = yield Serv.addComeIn(params);
      if (resultCode == 0) {
        return data;
      }
    } catch (error) {}
  });

  /**
   * 数据总览信息获取
   */
  getComeIn = flow(function* (params) {
    try {
      const { data, resultCode } = yield Serv.getComeIn(params);
      if (resultCode == 0) {
        this.reportObject = data;
        return data;
      }
    } catch (error) {}
  });

  /**
   * 上传视频
   */
  addVideo = flow(function* (params) {
    try {
      const { resultCode } = yield Serv.addVideo(params);
      return resultCode;
    } catch (error) {}
  });
  /**
   * 删除视频
   */
  delVideo = flow(function* (params) {
    try {
      const { resultCode } = yield Serv.delVideo(params);
      return resultCode;
    } catch (error) {}
  });
  /**
   * 用户关联视频
   */
  userConnectVideo = flow(function* (params) {
    try {
      const { data, resultCode } = yield Serv.userConnectVideo(params);
      return resultCode;
    } catch (error) {}
  });

  /**
   * 公司信息介绍
   */
  getCompanyIntroduce = flow(function* () {
    try {
      const { data, resultCode } = yield Serv.getCompanyIntroduce();
      if (resultCode == 0) {
        this.companyIntroduce = data;
        return data;
      }
    } catch (error) {}
  });

  /**
   * 保存访客信息
   */
  saveVisitUserInfo = flow(function* (prams) {
    try {
      const { data, resultCode } = yield Serv.saveVisitUserInfo(prams);
      return resultCode;
    } catch (error) {
      return false;
    }
  });

  /**
   * 赠送生日祝福
   */
  sendBirthDayWish = flow(function* (params) {
    try {
      const { data, resultCode } = yield Serv.sendBirthDayWish(params);
      if (+resultCode === 0) {
        this.showMadol = false;
        Toast.info('生日祝福赠送成功！');
      }
    } catch (error) {}
  });

  /**
   * 查看二维码是否允许
   */
  getQrcodeShow = flow(function* (id) {
    if (!id) return;
    try {
      const result = yield Serv.getQrcodeShow(id);
      const { data, resultCode } = result || {};
      const { mgmtQrStatus } = data || {};
      this.mgmtQrStatus = mgmtQrStatus;
    } catch (error) {
      return false;
    }
  });

  /**
   * 查询是否赠送过祝福
   */
  checkBirthdayWishes = flow(function* (params) {
    try {
      const result = yield Serv.checkBirthdayWishes(params);
      const { data } = result || {};
      return data;
    } catch (error) {
      return false;
    }
  });

  /**
   * 分享
   */
  shareBusinessCard = flow(function* (shareId, shareCardCode, shareName) {
    const isWeChat = Util.isWeiXin();
    const { realName, id, cardCode, belongSystem } = Stores.AppMod.userInfo || {};

    const shareUserId = shareId ? shareId : id;
    const shareUserCardCode = shareCardCode ? shareCardCode : cardCode;
    const shareUserName = shareName ? shareName : realName;

    if (isWeChat) {
      initConfig(true); // 初始化微信配置

      if ((this.info.phone || '').indexOf('*') != -1) {
        if (!this.decyptInfo.phone) {
          this.info.phone = yield Stores.AppMod.getDecyptMsg({
            scene: 224,
            id: this.info.id,
            channel: ''
          });
          this.decyptInfo = { ...this.decyptInfo, phone: this.info.phone };
          this.isSecret = false;
          Util.setLocalCache(Config.localStorageKeys.bussiness_card, {
            decyptInfo: this.decyptInfo
          });
        } else {
          this.info.phone = this.decyptInfo.phone;
        }
      }

      if (this.info.name.indexOf('*') != -1 || true) {
        if (!this.decyptInfo.name || true) {
          this.info.name = yield Stores.AppMod.getDecyptMsg({
            scene: 125,
            id: this.info.id,
            channel: ''
          });
          this.decyptInfo = { ...this.decyptInfo, name: this.info.name };
          Util.setLocalCache(Config.localStorageKeys.bussiness_card, {
            decyptInfo: this.decyptInfo
          });
        } else {
          this.info.name = this.decyptInfo.name;
        }
      }

      const title = `我是${decodeURI(shareUserName)}，您的健康管理顾问`;
      const desc = '三生（中国）优质健康管理专家，为您提供专业优质服务';
      const imgUrl = `${window.location.origin}/favicon.ico`;
      const link = `${window.location.origin}${
        window.location.pathname
      }#/promote/businessCard?id=${shareUserId}&cardCode=${shareUserCardCode}&shareName=${encodeURI(
        shareUserName
      )}&belongSystem=${belongSystem}&name=${encodeURI(this.info.name)}&phone=${this.info.phone}`;
      // 分享给朋友
      shareFriend({
        title,
        desc,
        imgUrl,
        link
      });
      // 分享到朋友圈
      sharePyq({
        title,
        imgUrl,
        link
      });
    }
  });

  /**
   * 三生体系未登录的情况下，是否显示下载app读公司的权限点
   * 获取权限点
   */
  getGongSiEnterList = flow(function* () {
    try {
      const { data } = yield Serv.getGongSiEnterList();
      if (data) {
        const list = [];
        for (let key in data) {
          const datas = data[key];
          datas.forEach((item) => {
            list.push(item.routeKey);
          });
        }

        const downloadKey = list.find((routerKey) => routerKey === routeAuthCodeMap.DOWNLOAD_BOOT);

        this.hasPermissions = !Stores.AppMod.token && !!downloadKey;
      }
    } catch (err) {
      console.log('dhsajkhd===>', err);
    }
  });

  /**
   * 新体系未登录的情况下，可以直接调取获取权限点
   * 获取权限点
   */
  getEnterList = flow(function* () {
    try {
      const { data } = yield Serv.getEnterList();

      const list = [];
      if (data) {
        //1-展业 2-我的 3-有享助手

        data.forEach((item) => {
          //enterType: 1-路由，2-标签
          list.push(item.routeKey);
        });

        const downloadKey = list.find((routerKey) => routerKey === routeAuthCodeMap.DOWNLOAD_BOOT);

        this.hasPermissions = !Stores.AppMod.token && !!downloadKey;
      }
    } catch (err) {
      console.log('dhjsakhda===>err', err);
    }
  });

  @action
  clearData() {
    this.info = {};
    this.decyptInfo = {};
  }
}
const businessCardMod = new BusinessCardMod();
export default businessCardMod;



// WEBPACK FOOTER //
// ./src/pages/Promote/BusinessCard/BusinessCardMod.js